export default __webpack_public_path__ + "static/dsc-01263@2x-473c9d1cd3325f322104a923ebd2f3c0.jpg";